'use client';

/**
 * «Спросить родителя» (pipeline v2, node 'ask'): heroes were picked but the
 * operation does not use them — the text is kept as it is, or retold. The
 * parent either adds the heroes to the story («добавить героев») or removes
 * them from the order.
 */
import { useTranslations } from 'next-intl';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';
import { Button } from '@/shared/components/ui/button';

export interface AskHeroesDialogProps {
  /** null = closed */
  kind: 'keep' | 'retell' | null;
  onAdd: () => void;
  onRemove: () => void;
  onCancel: () => void;
}

export function AskHeroesDialog({ kind, onAdd, onRemove, onCancel }: AskHeroesDialogProps) {
  const t = useTranslations('content.wizard.askHeroes');
  return (
    <AlertDialog open={kind !== null} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent data-testid="ask-heroes-dialog" data-kind={kind ?? ''}>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{kind ? t(`body.${kind}`) : ''}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel data-testid="ask-heroes-cancel">{t('cancel')}</AlertDialogCancel>
          <Button type="button" variant="outline" onClick={onRemove} data-testid="ask-heroes-remove">
            {t('remove')}
          </Button>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onAdd(); }} data-testid="ask-heroes-add">
            {t('add')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
